import React from "react";
import { MainCard } from "../../../components/surface/MainCard";
import { SectionBox } from "../../../components/surface/SectionBox";
import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import MotorImg from "../../../_assets/images/motor.png";

const MotorIndex = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/boat/order/motor");
    };

    return (
        <>
            <Card className="configureCard motor-order-card">

                <CardContent className="configureCardContent" sx={{ fontSize: "1.5rem", textAlign: "center" } }>
                    Bentley Outboard Partners
                    <CardMedia sx={{ height: 300, paddingTop: 20, backgroundSize: "100% 300px" }} image={MotorImg} title="Motor" />
                    <CardActions className="justify-center">
                        <Button
                            size="small"
                            variant="contained"
                            className="text-capitalize configureCardButton boat-ordering"
                            //onClick={() => navigate(`/boat/model/${series.id}`)}
                            onClick={handleClick}
                        >
                            Order outboard(s) for Bentley boats
                        </Button>
                    </CardActions>

                </CardContent>
            </Card>
        </>
    );
};

export default MotorIndex;
